import { render, staticRenderFns } from "./MembersActivity.vue?vue&type=template&id=08b2fe61&scoped=true"
import script from "./MembersActivity.vue?vue&type=script&lang=js"
export * from "./MembersActivity.vue?vue&type=script&lang=js"
import style0 from "./MembersActivity.vue?vue&type=style&index=0&id=08b2fe61&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "08b2fe61",
  null
  
)

export default component.exports